// extracted by mini-css-extract-plugin
export default {"container":"_2AVWb","list":"BKYxp","event":"Yjt6A","title":"OgG9_","chevron":"_2prY4","info":"_3hSOg","time":"jt07P"};